const puzzle_3d = `G U M M I K L U B B A R W M U I T Å E H T
U S I Ä K B O K A J R N R Ä J M Ä T S A U
R P E R F I H O P O L H Ä P Y L M B K O M
N I K S A M R R O B B A K S A A M E R E S
O K O T T E A R L S S M E J R U L K U A T
S P A J A J G S Y M R M O R A K N I V C O
M I L Ä S S V G G Å T A S T E Z Å K D A C
E S Å R R B T O R X F R Ö R B Ö J A R E K
V T U N F V A M I V E E R A T B K R A J R
S O R S I A S H P U I L E V E L I F G Å B
K L I K O T R Y N S N S O B R I N S A V R
R Ö B R Y T B L A D S K N I V Ö Y H R R Ä
U R O U T E M S Z Å E Å D T U R M I E S C
V O R V A N P N O D X D F A N N A V B E K
S N E M M P K Y L I N R E R P S E T U S J
T N R E S A I C K U Y T F T A P T O L K Ä
Y E Ä J Å S N K A S C K S Å R A V M T U R
C K O S V S B E L E K C Y N T F I K S T N
K O N E R A B L O L E D N G L I N S A T A
E L O L E L S E M M L I M Y O N G E X A S
P U S T J D A V U I F A O S T E R N A N O`


function transformRow(row) {
  row = row.replace(/\s/g, '')
  return Array.from(row).map(l => l.toLowerCase())
}

export function generatePuzzle_3d() {
  return puzzle_3d.split("\n").map(row => transformRow(row))
}

export const words_3d = [
  'Skiftnyckel',
  'Hammare',
  'Avbitartång',
  'Tumstock',
  'Hylsnyckel',
  'Morakniv',
  'Bågfil',
  'Torx',
  'Skruvdragare',
  'Bultsax',
  'Skruvstycke',
  'Stjärnskruvmejsel',
  'Polygrip',
  'Bräckjärn',
  'Stämjärn',
  'Brytbladskniv',
  'Spikpistol',
  'Tving',
  'Insexnyckel',
  'Vattenpass',
  'Rörböjare',
  'Gummiklubba',
  'Borrmaskin'
]
